import ErrorUtil from '../../../../../util/ErrorUtil';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import AbstractSignupScreen from './AbstractSignupScreen';

export default class ErrorOutSignupScreen extends AbstractSignupScreen {
  public screenName: UnifiedSignupScreenName = 'uss-error-out';

  // eslint-disable-next-line class-methods-use-this
  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    return 0;
  }

  public predicate(): boolean {
    const { isErroredOut } = this.sessionInfo.value;
    return isErroredOut;
  }

  // eslint-disable-next-line class-methods-use-this
  public async initWatchers(): Promise<void> {
    const elm = document.getElementById('error-form-container');
    if (!elm) {
      ErrorUtil.internalError({ msg: 'Could not find error-form-container' });
      return;
    }
    elm.classList.remove('d-none');
  }

  // eslint-disable-next-line class-methods-use-this
  public toNextScreen(): Promise<boolean> {
    throw new Error('Method not implemented.');
  }
}
